import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { ExtendedAssertion, ExtendedIssue } from "../../../../../domains/reports/models/BQ7ReportResponseDTO";

@Component({
  selector: "card-report-item",
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: "./card-report-item.component.html",
  styleUrls: ["./card-report-item.component.scss"]
})
export default class CardReportItem implements OnInit {
  breadcrumbText: string = "";
  itemText: string = "";

  @Input({ required: true }) item!: ExtendedIssue | ExtendedAssertion;

  @Input({ required: true })
  isNeedsAttentionCard: boolean;

  ngOnInit(): void {
    this.itemText = this.isNeedsAttentionCard ? (this.item as ExtendedIssue).text : (this.item as ExtendedAssertion).text;

    this.breadcrumbText = this.getBreadcrumb();
  }


  getBreadcrumb() {
    if (this.isNeedsAttentionCard && (this.item as ExtendedIssue).assertionText) {
      return this.issueBreadcrumb(this.item as ExtendedIssue);
    } else if ((this.item as ExtendedAssertion).text) {
      return this.breadcrumb(this.item as ExtendedAssertion);
    }

    return "";

  }


  issueBreadcrumb(issue: ExtendedIssue): string {
    return `${issue.areaName} | ${issue.assertionText}`;
  }

  breadcrumb(assertion: ExtendedAssertion): string {
    const parts: string[] = [];
    if (assertion.media?.length) {
      parts.push(`${assertion.media.length} image${assertion.media.length !== 1 ? "s" : ""}`);
    }
    // This is a CCM only component, so we only need to check for ccmNote
    if (assertion.ccmNote) {
      parts.push(`${assertion.ccmNote ? "1" : "0"} note${assertion.ccmNote ? "" : "s"}`);
    }

    return `${assertion.areaName}${parts.length ? " | " : ""}${parts.join(", ")}`;
  }
}